import React from 'react'
import bowser from 'bowser'
import '../Player.scss'
import preloaderUrl from '../assets/preloader.mp4'

// Checking bowser.name is empty for mobile
export default () => (
  bowser.mobile || !bowser.name
    ? (
      <div styleName="preloader-container">
        <div styleName="css-preloader"/>
      </div>
    )
    : (
      <div styleName="preloader" data-id="preloader" data-testid="preloader">
        <video src={preloaderUrl} autoPlay muted loop>
          <source src={preloaderUrl} type="video/mp4"/>
        </video>
      </div>
    )
)
